<div class="container-box">
  <div class="insurance-page">
    <!-- Header -->
    <div class="page-header">
      <div class="header-left">
        <h2 class="page-title">
          <i class="fas fa-shield-alt title-icon"></i>
          Gestione Assicurazioni
        </h2>
      </div>
      <div class="header-actions">
        <button class="btn-icon" (click)="reloadTrigger$.next()" title="Aggiorna">
          <i class="fas fa-sync-alt"></i>
        </button>
        <button class="btn-action" (click)="newInsurance()">
          <i class="fas fa-plus"></i>
          Nuova assicurazione
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="table-section">
      <app-new-table
        (btnDeleteClickEvent)="btnDeleteFunction($event)"
        (btnDetailsClickEvent)="btnDetailsClickFunction($event)"
        [dataSource]="dataSource"
        [displayedColumns]="displayedColumns"
        [initialSort]="{
          active: 'id',
          direction: 'desc'
        }"
        [reloadTrigger$]="reloadTrigger$"
        [additionalFilters]="additionalFilters"
      ></app-new-table>
    </div>
  </div>
</div>
